export default __webpack_public_path__ + "static/media/nova.7c919dc0.png";